/**
 * @generated SignedSource<<69dc70402d9bd7a717cdc4dc45adfe75>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Roles = "ADMIN" | "COWORKER_GROUP" | "CO_WORKER" | "MANAGER" | "READ_ONLY";
export type WidgetEmployeeLeaveSettingsMainQuery$variables = Record<PropertyKey, never>;
export type WidgetEmployeeLeaveSettingsMainQuery$data = {
  readonly store: {
    readonly myRole: Roles;
    readonly " $fragmentSpreads": FragmentRefs<"ManageEmployeeSchedueTypesListItem_store">;
  };
};
export type WidgetEmployeeLeaveSettingsMainQuery = {
  response: WidgetEmployeeLeaveSettingsMainQuery$data;
  variables: WidgetEmployeeLeaveSettingsMainQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "myRole",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "WidgetEmployeeLeaveSettingsMainQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ManageEmployeeSchedueTypesListItem_store"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "WidgetEmployeeLeaveSettingsMainQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "EmployeeScheduleType",
            "kind": "LinkedField",
            "name": "employeeScheduleTypes",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Team",
                "kind": "LinkedField",
                "name": "assignedTeams",
                "plural": true,
                "selections": [
                  (v1/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4e0152a7e9cc058410bda5f1ac2e5dfc",
    "id": null,
    "metadata": {},
    "name": "WidgetEmployeeLeaveSettingsMainQuery",
    "operationKind": "query",
    "text": "query WidgetEmployeeLeaveSettingsMainQuery {\n  store {\n    myRole\n    ...ManageEmployeeSchedueTypesListItem_store\n    id\n  }\n}\n\nfragment ManageEmployeeSchedueTypesListItem_store on Store {\n  employeeScheduleTypes {\n    id\n    assignedTeams {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "036cc4c67fc75153a069db0ec0b78799";

export default node;
